import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
// Importar estilos base (incluye Tailwind)
import './index.css';
import './shared/infrastructure/i18n/config'; // 👈 Carga la configuración al arrancar

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);